import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import aiRouter from "./modules/ai";
import aigcRouter from "./modules/aigc";
import agentRouter from "./modules/agent";
import dataRouter from "./modules/data";
import xhsRouter from "./modules/xhs";
import autowriteRouter from "./modules/autowrite";
import modelRouter from "./modules/model";
import shortvideoRouter from "./modules/shortvideo";
import toolkitRouter from "./modules/toolkit";
import helpRouter from "./modules/help";
import testRouter from "./modules/test";
import {routeMap, directPath, loginDirectPath, accountRoutePath} from "@/core/data/ConstData"

const routes = [
    {
        path: "/",
        redirect: "/ai",
        component: () => import("@/layout/Layout.vue"),
        children: [
            ...aiRouter,
            ...aigcRouter,
            ...agentRouter,
            ...dataRouter,
            ...xhsRouter,
            ...autowriteRouter,
            ...modelRouter,
            ...shortvideoRouter,
            ...toolkitRouter,
            ...helpRouter,
            ...testRouter
        ]
    },
    // {
    //     path: "/",
    //     redirect: "/help/maintain"
    // },
    {
        path: "/ai/forbidden",
        name: "ai-forbidden",
        component: () => import("@/views/error/forbidden.vue"),
    },
    {
        path: "/help/xhs/auth/:alias",
        name: "help-xhs-auth",
        component: () => import("@/views/help/xhsAuth.vue"),
    },
    {
        path: "/auth/login",
        name: "sign-in",
        component: () => import("@/views/auth/SignIn.vue"),
    },
    {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/error/Error404.vue"),
    },
    {
        path: "/500",
        name: "500",
        component: () => import("@/views/error/Error500.vue"),
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404",
    },
];


const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to,from) => {
    // store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });
    let path = to.path;
    if(directPath.includes(path) || path.startsWith('/help/xhs/auth')){

    }else{
        let type = store.getters.currentUser.type;
        let resourceCodeList = store.getters.resourceCodeList;
        const ROUTE_MAP = routeMap;
        console.log('path: '+to.path)
        if(type == 2){
            let path = to.path
            if(path.startsWith("/ai/chat/general")){
                path = "/ai/chat/general"
            }
            let m = ROUTE_MAP[path];
            console.log('path: '+to.path+' m:'+m)
            if(m){
                if(!resourceCodeList.includes(m)){
                    router.push({ path: '/ai'});
                    return false
                }else{
                    store.getters.resourceList.forEach((item) => {
                        if(m == item['code']){
                            store.commit(Mutations.SET_ACCOUNT_MENU_ACTIVE_INDEX, item['id']);
                        }
                    })
                }
            }else if(!loginDirectPath.includes(to.path)){
                store.commit(Mutations.SET_ACCOUNT_MENU_ACTIVE_INDEX, '');
                let accountPrivilege = store.getters.currentUser.accountPrivilege;
                if(accountPrivilege == 0 || (accountPrivilege == 1 && !accountRoutePath.includes(to.path))){
                    router.push({ path: '/ai'});
                    return false
                }
            }
        }
        // Scroll page to top on every route change
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }
});

router.afterEach((to, from, failure) => {
    let path = to.path;
    if(directPath.includes(path)){
        
    }else{
        // if(to.path == '/account/list'){
        //     let type = store.getters.currentUser.type;
        //     if(type == 2){
        //         router.replace({ path: '/ai'});
        //         return false
        //     }
        // }
        store.commit(Mutations.SET_CURRENT_PATH, to.fullPath);
        // console.log('router after: from ',from.fullPath, ' to ', to.fullPath);
    }

})

export default router;